import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import DispatchedOrdersLayer from "../../components/orders/DispatchedOrdersLayer";

const DispatchedOrdersPage = () => {
    return (
        <MasterLayout>
            <DispatchedOrdersLayer />
        </MasterLayout>
    );
};

export default DispatchedOrdersPage;
